import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LEGAL_LINKS = [
  { slug: "participant-agreement", label: "Participant Service Agreement" },
  { slug: "enrollment-agreement", label: "Program Enrollment Agreement" },
  { slug: "terms", label: "Website Terms & Conditions" },
  { slug: "privacy", label: "Privacy Policy" },
];

// Retired slugs now covered by the current documents (old versions stay viewable via ?version=).
export const LEGACY_REDIRECTS = {
  membership: "enrollment-agreement",
  registration: "enrollment-agreement",
  waiver: "participant-agreement",
  refunds: "participant-agreement",
  media: "participant-agreement",
};

export async function getLegalDoc(slug, version) {
  const { data } = await axios.get(`${API}/legal/${slug}`, { params: version ? { version } : {} });
  return data;
}

export async function previewAgreements(payload) {
  const { data } = await axios.post(`${API}/programs/agreement-preview`, payload);
  return data;
}
